import {
  BUDGET_CREATE_REQUEST_FAIL,
  BUDGET_CREATE_REQUEST_SUCCESS,
  BUDGET_DELETE_REQUEST_FAIL,
  BUDGET_DELETE_REQUEST_SUCCESS,
  BUDGET_UPDATE_REQUEST_FAIL,
  BUDGET_UPDATE_REQUEST_SUCCESS,
  SELECT_BUDGET,
  BUDGET_FIND_REQUEST_SUCCESS
} from "../action.types";
import initialState from "../initial.state";
import BudgetBuildFormObject from "../../pages/budget/BudgetBuildFormObject";

export default function(state = initialState.budget, action) {
  switch (action.type) {
    case SELECT_BUDGET:
      return { ...state, ...action.budget };
    case BUDGET_FIND_REQUEST_SUCCESS:
      return { ...BudgetBuildFormObject(action.payload) };
    case BUDGET_CREATE_REQUEST_SUCCESS:
      return state;
    case BUDGET_CREATE_REQUEST_FAIL:
      return state;
    case BUDGET_UPDATE_REQUEST_SUCCESS:
      return { ...state, ...action.payload };
    case BUDGET_UPDATE_REQUEST_FAIL:
      return state;
    case BUDGET_DELETE_REQUEST_SUCCESS:
      return state;
    case BUDGET_DELETE_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/budget/budget.reducer.js